<template>
  <div>
    <Header></Header>
    <div class="col-12 main-content">
      <div>
        <div class="row">
          <div class="col-10 ms-3 me-3 pt-3 padding-bottom-XXL">

            <!-- CHANNEL INFO -->
            <div v-if="currentChannel" class="row">
              <div class="col-12">
                <div class="channel-details-card p-3 mb-3">
                  <h5 class="text-center mb-3">Selected channel</h5>

                  <div class="row g-2">
                    <div class="col-12 col-md-2 user-info-item">
                      <strong>Channel ID:</strong> {{ currentChannel.channelId }}
                    </div>
                    <div class="col-12 col-md-3 user-info-item">
                      <strong>Channel Name:</strong> {{ currentChannel.channelName }}
                    </div>
                    <div class="col-12 col-md-2 user-info-item">
                      <strong>Event IDs:</strong> {{ (currentChannel.eventIds || []).join(', ') }}
                    </div>
                    <div class="col-12 col-md-2 user-info-item">
                      <strong>Status:</strong> {{ currentChannel.status }}
                    </div>
                    <div class="col-12 col-md-2 user-info-item">
                      <strong>Active:</strong> {{ currentChannel.active }}
                    </div>
                  </div>
                </div>
              </div>
            </div>



            <hr class="solid">
            <!-- BACKEND HEALTH STATUS -->
            <div class="box-outline mt-4">
              <div class="mx-2 my-3">
                <h4 class="mb-2">Backend Health:</h4>

                <pre>{{ healthStatus }}</pre>
              </div>
            </div>
            <!-- END BACKEND HEALTH STATUS -->

            <!-- SEGMENT: PROVIDER SELECT -->
            <div class="box-outline mt-4">
              <div class="mx-2 my-3 encoder-row">
                <h4 class="mb-0 me-3">Encoder:</h4>
                <Multiselect
                    v-model="selectedEncoder"
                    :options="encoderOptions"
                    placeholder="Select encoder"
                    class="multiselect-blue provider-select"
                    style="width: 300px"
                />
              </div>
            </div>

            <!-- Load Xaccel stream selector only for xaccel providers -->
            <ChannelXaccelStreams
                v-if="selectedEncoder && selectedEncoder.startsWith('xaccel')"
                :selected-encoder="selectedEncoder"
                :current-channel="currentChannel"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import Multiselect from '@vueform/multiselect'
import ChannelXaccelStreams from '@/components/ChannelXaccelStreams.vue'
import XaccelService from '@/services/xaccel-service'

export default defineComponent({
  name: 'ChannelPostStream',
  components: {
    Header,
    Multiselect,
    ChannelXaccelStreams
  },
  data () {
    return {
      editedConfig: {
        channelId: this.$route.params.channelId,
        channelName: this.$route.params.channelName,
        eventIds: this.$route.params.eventIds,
        caption: this.$route.params.caption,
        protectKey: this.$route.params.protectKey,
        tags: this.$route.params.tags,
        appName: this.$route.params.appName,
        edgePort: this.$route.params.edgePort,
        liveViews: this.$route.params.liveViews,
        totalViews: this.$route.params.totalViews,
        orderNumber: this.$route.params.orderNumber,
        status: this.$route.params.status,
        active: this.$route.params.active
      },
      healthStatus: null,

      selectedEncoder: null,
      encoderOptions: [
        { value: 'xaccel-de', label: 'xaccel-de' },
        { value: 'xaccel-uk', label: 'xaccel-uk' }
        // add other encoders later; xaccel-specific UI is in the child
      ]
    }
  },
  computed: {
    currentChannel () {
      return this.editedConfig && this.editedConfig.channelId
          ? this.editedConfig
          : null
    }
  },
  methods: {
    fetchHealth() {
      XaccelService.getBackendHealth()
          .then(res => {
            this.healthStatus = res;
          })
          .catch(() => {
            this.healthStatus = { status: 'DOWN' };
          });
    }
  },mounted() {
    this.fetchHealth();
  }


})
</script>

<style src="../../assets/style.css">
</style>
